const detail = {
  invoiceInfo: [
    {
      name: 'fullName',
      text: 'common.input_name'
    },
    {
      name: 'organizationName',
      text: 'user.user_company-name'
    },
    {
      name: 'phone',
      text: 'common.input_phone-number',
      component: 'PhoneNumberInput'
    },
    {
      name: 'country',
      text: 'common.input_country',
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectCountry'
    },
    {
      name: 'postalCode',
      text: 'common.input_postal-code',
      cols: Math.ceil((12 - 3) / 2)
    },
    {
      name: 'region',
      text: 'common.input_region',
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectRegion'
    },
    {
      name: 'address1',
      text: 'common.input_address_1'
    },
    {
      name: 'address2',
      text: 'common.input_address_2'
    }
  ],
  receiverInfo: [
    {
      name: 'receiverName',
      text: 'sale.sale_pecipient'
    },
    {
      name: 'organizationName',
      text: 'user.user_company-name'
    },
    {
      name: 'fullName',
      text: 'common.input_name'
    },
    {
      name: 'phone',
      text: 'common.input_phone-number',
      component: 'PhoneNumberInput'
    },
    {
      name: 'country',
      text: 'common.input_country',
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectCountry'
    },
    {
      name: 'postalCode',
      text: 'common.input_postal-code',
      cols: Math.ceil((12 - 3) / 2)
    },
    {
      name: 'region',
      text: 'common.input_region',
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectRegion'
    },
    {
      name: 'address1',
      text: 'common.input_address_1'
    },
    {
      name: 'address2',
      text: 'common.input_address_2'
    }
  ],
  saleInfo: [
    {
      name: 'currency',
      text: 'common.input_currency',
      required: true,
      cols: Math.ceil((12 - 3) / 2),
      component: 'SelectCurrency'
    },
    {
      name: 'saleDate',
      text: 'sale.sale_order-date',
      required: true,
      cols: Math.ceil((12 - 3) / 2) - 1,
      component: 'NormalDatePicker'
    }
  ]
}

export default { detail }
